const MAX_IMAGE_BYTES = 8 * 1024 * 1024;
const ALLOWED_TYPES = new Set(["image/png", "image/jpeg", "image/webp"]);

export async function readImageFileAsDataUrl(file: File): Promise<string> {
  if (!ALLOWED_TYPES.has(file.type)) {
    throw new Error("ใช้ได้เฉพาะ PNG, JPEG หรือ WebP");
  }
  if (file.size > MAX_IMAGE_BYTES) {
    throw new Error("ไฟล์ใหญ่เกิน 2 MB");
  }

  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") resolve(reader.result);
      else reject(new Error("อ่านไฟล์ไม่สำเร็จ"));
    };
    reader.onerror = () => reject(new Error("อ่านไฟล์ไม่สำเร็จ"));
    reader.readAsDataURL(file);
  });

  await assertImageLoads(dataUrl);
  return dataUrl;
}

function assertImageLoads(dataUrl: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error("ไฟล์นี้ไม่ใช่รูปภาพที่ใช้ได้"));
    img.src = dataUrl;
  });
}
